import React from "react";


const NoMatch=()=>{
    return <div>404 not found</div>
}


export default NoMatch